import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

/**
 * GroupLabel: Display the Main Bold Group title
 * of GroupLabel
 */
export function GroupLabel(props) {
  const setStyle = () => ({color: props.color, borderColor: props.color});

  return (
    <div style={setStyle()} className={`${props.wrapClass}__title`}>
      <h3>{props.title}</h3>
    </div>
  );
}

GroupLabel.propTypes = {
  /**
   * Title string to be displayed here
   */
  title: PropTypes.string,
  /**
   * Theme color of the group
   */
  color: PropTypes.string,
  /**
   * The className to be set as prefix
   */
  wrapClass: PropTypes.string,
};
